import React from "react";

type Props = {
  testId?: string;
  caption?: string;
  label: string;
  min: number;
  max: number;
  step: number;
  placeholder?: string;
  value: number | undefined;
  setValue: (value: number | undefined) => void;
};

export const PromptNumberField: React.FC<Props> = ({
  testId,
  caption,
  label,
  min,
  max,
  step,
  placeholder,
  value,
  setValue,
}) => (
  <form className="txu-form-field tw-mb-4">
    <label
      data-balloon={caption}
      data-balloon-pos="up-left"
      data-balloon-length="xlarge"
    >
      {label}
    </label>
    <p>Value: {value ?? "OpenRouter default"}</p>
    <input
      className="tw-w-64"
      data-testid={testId}
      type="number"
      min={min}
      max={max}
      step={step}
      placeholder={placeholder}
      value={value ?? ""}
      onChange={(e) => {
        const parsed = parseInt(e.target.value, 10);
        setValue(Number.isFinite(parsed) ? parsed : undefined);
      }}
    />
  </form>
);
